var Countries = {
    ARGENTINA: 'argentina',
    URUGUAY: 'uruguay',
    ECUADOR: 'ecuador',
    DOMINICANA: 'dominicana'
};
export default Countries;
